import React from 'react';
import Img from 'gatsby-image';

const Hero = props => {
  const { image, heading, children } = props;

  return (
    <div className="row full-width hero">
      <Img
        sizes={image}
        style={{
          width: '100%',
          height: '100%',
        }}
        imgStyle={{ width: '100%', height: '100%' }}
      />
      <div className="header">
        <h1 className="heading">{heading}</h1>
        {children}
      </div>
    </div>
  );
};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.js